import angular from 'angular';
import { Log } from '../../log';
const log = Log.channel('VolumeControlsExtension');
export class VolumeControlsExtension {
    constructor($scope, $ionicPopover, $timeout, $window, $ionicPosition, IosTouchEventService, template = 'whoCanHearMeVolumeControl.html', sliderOptions = {}) {
        this.$scope = $scope;
        this.$ionicPopover = $ionicPopover;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$ionicPosition = $ionicPosition;
        this.IosTouchEventService = IosTouchEventService;
        this.template = template;
        this.incrementVolume = 0;
        this.areVolumeControlsVisible = (getterSetter) => {
            return this.volumeGetterSetter === getterSetter;
        };
        this.hideVolumeControls = () => {
            if (this.volumeControls !== undefined) {
                return this.volumeControls.remove();
            }
            return null;
        };
        this.onHideVolumeControls = () => {
            if (this.volumeControls !== undefined && this.volumeControls.isShown()) {
                this.volumeControls.hide();
            }
        };
        this.onVolumeChanged = (sliderId, value) => {
            if (this.isVolumeHeld) {
                this.setVolume(value);
            }
        };
        this.onVolumeHold = () => {
            this.isVolumeHeld = true;
            this.isUserChangingVolume = true;
            this.saveVolume = undefined;
        };
        this.onVolumeRelease = () => {
            this.isVolumeHeld = false;
            this.scheduleVolumeRelease();
        };
        this.onVolumeMuteStateValueChanged = (newValue, oldValue) => {
            this._volumeMute = newValue;
        };
        this.onVolumeStateValueChanged = (newValue, oldValue) => {
            if (this.isUserChangingVolume) {
                this.saveVolume = newValue;
                this.scheduleVolumeRelease();
            }
            else {
                this._volume = newValue;
            }
        };
        this.positionVolumeControlsView = (target, popoverEle) => {
            var _a;
            // Adapted from $ionicPopover source
            const POPOVER_BODY_PADDING = 6;
            const targetEle = angular.element(target.target || target);
            const buttonOffset = this.$ionicPosition.offset(targetEle);
            const popoverWidth = popoverEle.prop('offsetWidth');
            const popoverHeight = popoverEle.prop('offsetHeight');
            // Use innerWidth and innerHeight, because clientWidth and clientHeight
            // doesn't work consistently for body on all platforms
            const bodyWidth = this.$window.innerWidth;
            const bodyHeight = this.$window.innerHeight;
            const popoverCSS = {
                left: buttonOffset.left + buttonOffset.width / 2 - popoverWidth / 2,
                top: 0,
            };
            const arrowEle = angular.element((_a = popoverEle[0].querySelector('.arrow-left')) !== null && _a !== void 0 ? _a : '');
            if (popoverCSS.left < POPOVER_BODY_PADDING) {
                popoverCSS.left = POPOVER_BODY_PADDING;
            }
            else if (popoverCSS.left + popoverWidth + POPOVER_BODY_PADDING > bodyWidth) {
                popoverCSS.left = bodyWidth - popoverWidth - POPOVER_BODY_PADDING;
            }
            // If the popover when popped down stretches past bottom of screen,
            // adjust it to fit.
            if (buttonOffset.top + popoverHeight > bodyHeight) {
                popoverCSS.top = bodyHeight - popoverHeight;
            }
            else {
                popoverCSS.top = buttonOffset.top;
            }
            arrowEle.css({
                top: buttonOffset.top +
                    buttonOffset.height / 2 -
                    arrowEle.prop('offsetHeight') / 2 -
                    popoverCSS.top +
                    'px',
            });
            popoverEle.css({
                top: popoverCSS.top + 'px',
                left: popoverCSS.left + 'px',
                marginLeft: '0',
                opacity: '1',
            });
        };
        this.releaseVolume = () => {
            if (!this.isVolumeHeld) {
                this.isUserChangingVolume = false;
                if (this.saveVolume !== undefined) {
                    this._volume = this.saveVolume;
                }
            }
        };
        this.scheduleVolumeRelease = () => {
            this.$timeout.cancel(this.volumeReleasePromise);
            this.volumeReleasePromise = this.$timeout(this.releaseVolume, 300);
        };
        this.setVolume = (newValue) => {
            log.debug('setVolume = ' + newValue);
            if (this.volumeGetterSetter !== undefined) {
                this.volumeGetterSetter(newValue);
            }
        };
        this.showVolumeControls = (options, $event) => {
            const show = () => {
                this.$ionicPopover
                    .fromTemplateUrl(this.template, {
                    scope: this.$scope,
                    // HACK/undocumented: positionView overrides an internal
                    // positioning function, due to being combined via an internal
                    // .extend()
                    positionView: this.positionVolumeControlsView,
                })
                    .then((popover) => {
                    var _a;
                    this.volumeControls = popover;
                    this._isVolumeStateless = !!options.isVolumeStateless;
                    this.volumeMuteGetterSetter = options.volumeMute;
                    this.volumeGetterSetter = options.volume;
                    this.volumeUnwatch = this.$scope.$watch(() => {
                        return this.volumeGetterSetter ? this.volumeGetterSetter() : 0;
                    }, this.onVolumeStateValueChanged);
                    this.volumeMuteUnwatch = this.$scope.$watch(() => {
                        return this.volumeMuteGetterSetter ? this.volumeMuteGetterSetter() : false;
                    }, this.onVolumeMuteStateValueChanged);
                    (_a = this.volumeControls) === null || _a === void 0 ? void 0 : _a.show($event).then(() => {
                        this._sliderHidden = false;
                    });
                });
            };
            const hiding = this.hideVolumeControls();
            if (!hiding) {
                show();
            }
            else {
                hiding.then(show);
            }
        };
        this.wrappedVolumeHandlers = this.IosTouchEventService.wrapHandlers(($event, increment) => {
            var _a, _b;
            if (increment === undefined) {
                increment = 1;
            }
            if (!this.isIncrementVolumeHeld && this.volume !== null) {
                this.incrementVolume = this.volume;
            }
            this.incrementVolume = Math.max((_a = this.sliderOptions.floor) !== null && _a !== void 0 ? _a : 0, Math.min((_b = this.sliderOptions.ceil) !== null && _b !== void 0 ? _b : 0, this.incrementVolume + increment));
            this.isIncrementVolumeHeld = true;
            this.isUserChangingVolume = true;
            this.saveVolume = undefined;
            this._volume = this.incrementVolume;
            this.setVolume(this.incrementVolume);
        }, ($event) => {
            this.isIncrementVolumeHeld = false;
            this.scheduleVolumeRelease();
        });
        this.incrementVolumeRelease = this.wrappedVolumeHandlers.onRelease;
        this.incrementVolumeTouch = this.wrappedVolumeHandlers.onTouch;
        this.isIncrementVolumeHeld = false;
        this.isUserChangingVolume = false;
        this.isVolumeHeld = false;
        this._isVolumeStateless = false;
        this._volumeMute = false;
        this._sliderHidden = true;
        this._sliderOptions = {
            ceil: 12,
            disableAnimation: true,
            floor: -12,
            interval: 10,
            hideLimitLabels: true,
            hidePointerLabels: true,
            onStart: this.onVolumeHold,
            onChange: this.onVolumeChanged,
            onEnd: this.onVolumeRelease,
            showSelectionBar: true,
            vertical: true,
        };
        this._volume = 0;
        this.toggleVolumeMute = () => {
            if (this.volumeMuteGetterSetter !== undefined) {
                this.volumeMuteGetterSetter(true);
            }
        };
        log.info('initializing');
        angular.extend(this.sliderOptions, sliderOptions);
        this.$scope.$on('popover.hidden', ($event, popover) => {
            if (popover === this.volumeControls) {
                popover.remove();
            }
        });
        this.$scope.$on('popover.removed', ($event, popover) => {
            if (popover === this.volumeControls) {
                if (this.volumeUnwatch) {
                    this.volumeUnwatch();
                    this.volumeUnwatch = undefined;
                }
                this.volumeGetterSetter = undefined;
                this.volumeControls = undefined;
                this._sliderHidden = true;
            }
        });
        this.$scope.$on('IdleTimeout', this.onHideVolumeControls);
        this.$scope.$on('WhoCanHearMeInit', this.onHideVolumeControls);
    }
    get hasVolumeMute() {
        return this.volumeMuteGetterSetter !== undefined;
    }
    get hasVolume() {
        return this.volumeGetterSetter !== undefined;
    }
    get isVolumeStateless() {
        return this._isVolumeStateless;
    }
    get volumeMute() {
        return this._volumeMute;
    }
    set volumeMute(mute) {
        this._volumeMute = mute;
    }
    get sliderHidden() {
        return this._sliderHidden;
    }
    get sliderOptions() {
        return this._sliderOptions;
    }
    get volume() {
        return this._volume;
    }
    set volume(vol) {
        this._volume = vol;
    }
}
VolumeControlsExtension.$inject = [
    '$scope',
    '$ionicPopover',
    '$timeout',
    '$window',
    '$ionicPosition',
    'IosTouchEventService',
];
